import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tailwind.css';
import './styles/index.css';
import 'leaflet/dist/leaflet.css';
import { validateEnvironment } from './config/env';

// Validate environment variables before app initialization
try {
  validateEnvironment();
} catch (error) {
  console.error('Environment validation failed:', error?.message);
  // In production, show error to user instead of breaking silently
  if (import.meta.env?.VITE_ENV === 'production') {
    document.body.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: system-ui, -apple-system, sans-serif;">
        <div style="text-align: center; max-width: 500px; padding: 2rem;">
          <h1 style="font-size: 2rem; color: #ef4444; margin-bottom: 1rem;">⚠️ Configuration Error</h1>
          <p style="color: #6b7280; margin-bottom: 1rem;">${error?.message}</p>
          <p style="color: #9ca3af; font-size: 0.875rem;">Please contact support if this issue persists.</p>
        </div>
      </div>
    `;
    throw error;
  }
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);